import type { FieldKey } from '@jira/polaris__domain-field/src/FieldKey.types.tsx';
import {
	fireTrackAnalytics,
	type UIAnalyticsEvent,
} from '@atlassian/jira-product-analytics-bridge';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { StoreActionApi } from '@atlassian/react-sweet-state';
import { createGetFieldByKey } from './createGetFieldByKey.tsx';
import type { Props, State } from './FieldsUpdate.types.tsx';

export const updateDeliveryDateSelectedField =
	(
		fieldKey: FieldKey,
		selectedFieldKey: string | undefined,
		contextAnalyticsEvent: UIAnalyticsEvent,
	) =>
	async (
		{ getState, setState }: StoreActionApi<State>,
		{ fieldRemote }: Props,
		// oxlint-disable-next-line typescript/no-invalid-void-type
	): Promise<Error | void> => {
		const state = getState();
		// oxlint-disable-next-line typescript/no-non-null-assertion
		const currentField = createGetFieldByKey(fieldKey)(state)!;

		const oldConfiguration = currentField.configuration ? currentField.configuration : {};
		const newConfiguration = { ...currentField.configuration };

		if (selectedFieldKey) {
			newConfiguration.customfieldKey = selectedFieldKey;
		} else {
			delete newConfiguration.customfieldKey;
		}

		const fields = { ...getState().fields };
		fields[fieldKey] = {
			...fields[fieldKey],
			configuration: newConfiguration,
		};
		setState({ fields });

		await fieldRemote.updateFieldConfiguration({
			fieldKey,
			oldConfiguration,
			configuration: newConfiguration,
			type: 'updateDeliveryDateSelectedField',
		});

		fireTrackAnalytics(contextAnalyticsEvent, 'issueFields updated', {
			issueFieldKey: fieldKey,
			issueFieldType: currentField.type,
			updatedItems: [{ name: 'customfieldKey' }],
		});
	};
